module.exports = __webpack_public_path__ + "static/logo-women-179550bca4cc4678f7b4a4e6831fa6dd.png";